module.exports = __webpack_public_path__ + "img/Bitmap@241x.15d9ed48.png";